'use client'

import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface FeatureItem {
	icon: string
	title: string
	description: string
}

const features: FeatureItem[] = [
	{
		icon: '/images/b2c/directions_icon_1.svg',
		title: 'Ломбард',
		description:
			'Моментальные и безопасные выплаты клиентам на карту прямо в момент приёма ценностей оценщиком.'
	},
	{
		icon: '/images/b2c/directions_icon_2.svg',
		title: 'Автодилеры',
		description:
			'Переводы предоплаты или полной стоимости автомобиля физлицам при совершении сделок выкупа.'
	},
	{
		icon: '/images/b2c/directions_icon_3.svg',
		title: 'Приём лома',
		description:
			'Выдача денежных средств на карты ломосдатчиков сразу после взвешивания и приёма товара.'
	},
	{
		icon: '/images/b2c/directions_icon_4.svg',
		title: 'Сервисные компании',
		description:
			'Расчёты с выездными мастерами, курьерами и подрядчиками сразу после оказания услуг.'
	},
	{
		icon: '/images/b2c/directions_icon_5.svg',
		title: 'Сбор вторсырья',
		description:
			'Выплата за сданные объёмы картона, плёнки или стеклотары — оператор весов рассчитывается в один клик.'
	}
]

const Directions: React.FC = () => {
	const [isMobile, setIsMobile] = useState(false)

	useEffect(() => {
		const checkIsMobile = () => {
			setIsMobile(window.innerWidth <= 767)
		}
		checkIsMobile()
		window.addEventListener('resize', checkIsMobile)
		return () => window.removeEventListener('resize', checkIsMobile)
	}, [])

	return (
		<section className={styles.directions}>
			<div className={styles.container}>
				<div className={styles.content}>
					<AnimatedSection animation='slideUp'>
						<div className={styles.subtitle}>Направления</div>
						<h2
							className={styles.title}
							dangerouslySetInnerHTML={{ __html: '<span>Для какой деятельности бизнеса</span> подходит наше решение' }}
						/>
					</AnimatedSection>
					<AnimatedSection animation='slideUp'>
						<p
							className={styles.description}
							dangerouslySetInnerHTML={{
								__html:
									'Сервис адаптирован под специфику компаний, где скорость выдачи денег физлицу определяет лояльность клиентов и непрерывность процессов.'
							}}
						/>
					</AnimatedSection>
					<div className={styles.featuresGrid}>
						{features.map((feature, index) => (
							<AnimatedSection key={index} animation='slideUp' className={styles.featureCard}>
								<div className={styles.featureIcon}>
									<Image
										src={feature.icon}
										alt={feature.title}
										width={isMobile ? 32 : 40}
										height={isMobile ? 32 : 40}
									/>
								</div>
								<h3 className={styles.featureTitle}>{feature.title}</h3>
								<p className={styles.featureDescription}>{feature.description}</p>
							</AnimatedSection>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

Directions.displayName = 'Directions'

export default Directions
